import React, { useState, useEffect } from 'react';
import './SpineLabel.css'; // Import your CSS file for styling
import * as Constants from '../../Constant/constant';
import SearchableSelect from '../../shared/SearchableSelect';

function SpineLabel({ showSpineLabel }) {
    const [bookTypesSpineLabel, setBookTypesSpineLabel] = useState([]);
    const [loadingBookTypesSpineLabel, setLoadingBookTypesSpineLabel] = useState(true);
    const [errorBookTypesSpineLabel, setErrorBookTypesSpineLabel] = useState(null);
    const [selectedBookTypeSpineLabel, setSelectedBookTypeSpineLabel] = useState('');
    const [bookNoFromSpineLabel, setBookNoFromSpineLabel] = useState('');
    const [bookNoToSpineLabel, setBookNoToSpineLabel] = useState('');

    useEffect(() => {
        // Fetch book types for spine labels
        const fetchBookTypes = async () => {
            setLoadingBookTypesSpineLabel(true);
            setErrorBookTypesSpineLabel(null);
            try {
                const response = await fetch(Constants.API_PATH +'/book_types'); // Replace with your API endpoint
                if (!response.ok) {
                    throw new Error('Failed to fetch book types');
                }
                const data = await response.json();
                setBookTypesSpineLabel(data);
            } catch (error) {
                setErrorBookTypesSpineLabel(error.message);
            } finally {
                setLoadingBookTypesSpineLabel(false);
            }
        };

        fetchBookTypes();
    }, []);

    const handleBookTypeChangeSpineLabel = (e) => {
        setSelectedBookTypeSpineLabel(e.target.value);
    };

    const handleBookNoFromChangeSpineLabel = (e) => {
        setBookNoFromSpineLabel(e.target.value);
    };

    const handleBookNoToChangeSpineLabel = (e) => {
        setBookNoToSpineLabel(e.target.value);
    };

    const handleGenerateSpineLabel = () => {
        // Logic to generate spine labels
        console.log('Generating spine labels for:', selectedBookTypeSpineLabel, bookNoFromSpineLabel, bookNoToSpineLabel);
        // Add your generation logic here
    };

    return (
        showSpineLabel && (
            <div className="spine-label-section containernew">
                {/* <nav className="breadcrumb">
                    <a href="#" className="breadcrumb-link">Home</a> /
                    <a href="#" className="breadcrumb-link">Library Management</a> /
                    <span className="breadcrumb-current">Spine Label</span>
                </nav> */}
                <h2 className="section-title">Spine Label</h2>
                <div className="form-section">
                    <div className="form-group">
                        <label htmlFor="bookTypeSpineLabel" className="form-label">Book Type</label>
                        <SearchableSelect
                            id="bookTypeSpineLabel"
                            className="form-select"
                            value={selectedBookTypeSpineLabel}
                            onChange={handleBookTypeChangeSpineLabel}
                            options={bookTypesSpineLabel.map((bookType) => ({
                                value: bookType.id,
                                label: bookType.name
                            }))}
                            loading={loadingBookTypesSpineLabel}
                            placeholder="--Select Book Type--"
                            noOptionsMessage={errorBookTypesSpineLabel ? `Error: ${errorBookTypesSpineLabel}` : 'No results found'}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="bookNoFromSpineLabel" className="form-label">Book No From</label>
                        <input
                            type="text"
                            id="bookNoFromSpineLabel"
                            className="form-input"
                            placeholder="Book No From"
                            value={bookNoFromSpineLabel}
                            onChange={handleBookNoFromChangeSpineLabel}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="bookNoToSpineLabel" className="form-label">Book No To</label>
                        <input
                            type="text"
                            id="bookNoToSpineLabel"
                            className="form-input"
                            placeholder="Book No To"
                            value={bookNoToSpineLabel}
                            onChange={handleBookNoToChangeSpineLabel}
                        />
                    </div>
                </div>
                <button className="generate-button" onClick={handleGenerateSpineLabel}>Generate</button>
            </div>
        )
    );
}

export default SpineLabel;